import { adminUsersByIdLinksInvitationPostSlice } from './post';

export const {
	requestPostAdminUsersByIdLinksInvitationSend,
	resetPostAdminUsersByIdLinksInvitationSend
} = adminUsersByIdLinksInvitationPostSlice.asyncActionCreators;
